<template>
    <div>
        <div class="class-list" >
            <div class="class-title">
                <div class="title-wrap">
                    <span></span>{{params.title}}
                </div>
                 <router-link v-if="params.lookMore" :to="{name:'videoclassify'}" >
                    <i>{{$t('more')}}</i>
                </router-link>
            </div>
            <div class="class-item-wrap">
                <div class="class-item" v-for="item in params.list" :key="item.id" @click="detail(item)">
                    <div class="videp-cover" :style="{backgroundImage: `url(${item.cover})`, backgroundSize: 'cover'}"></div>
                    <img v-if="item.price > 0" class="vip" src="@/assets/images/video/vip.png" alt="">
                    <div class="title">{{item.title}}</div>
                    <div class="bot">
                        <span>{{$t('author')}}：{{item.author}}</span>
                        <span>{{$t('views')}}：{{item.pv}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        params: {
            type: [Object, Array]
        }
    },
    methods: {
        detail(item) {
            const { href } =  this.$router.resolve({
                name: 'videodetail',
                params: {
                    videoId: item.id
                }
            })
            window.open(href, '_blank')
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/mixin.scss';
@import '@/assets/css/variable.scss';
.class-list {
    background: #ffffff;
    width: 1226px;
    margin: 20px auto 0;
    padding: 30px;
    margin-bottom: 20px;
    box-sizing: border-box;
}
.class-title {
    color: #333333;
    font-size: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    span {
        display: inline-block;
        width: 6px;
        height: 38px;
        background: #FF6D6D;
        border-radius: 4px;
        margin-right: 7px;
    }
    .title-wrap {
        display: flex;
        align-items: center;
    }
}

.class-item-wrap {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .class-item{
        width: 220px;
        margin-top: 20px;
        margin-bottom: 10px;
        margin-left: 16px;
        padding: 10px;
        cursor: pointer;
        position: relative;
        box-sizing: border-box;
        &:hover {
            box-shadow: 0 15px 20px rgba(0,0,0,0.1);
        }
        .vip {
            position: absolute;
            right: 10px;
            top: 10px;
            width: 50px;
            height: 26px;
        }
        &:first-child {
            margin-left: 0;
        }
        &:nth-child(6n) {
            margin-left: 0;
        }
        .videp-cover {
            width: 200px;
            height: 121px;
            border-radius: 10px;
        }
        .title {
            height: 38px;
            margin: 10px 0;
            line-height: 20px;
            @include no-wrap-line(2)
        }
        .bot{
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
    }
}
</style>